import cn from 'classnames';
import NavLink from 'organisms/Navigation/NavLink';
import NavMenu from 'organisms/Navigation/NavMenu';
import React from 'react';
import { IMenuItem, INavItem } from 'utils/globalTypes';
import { useUserAuth } from 'utils/hooks/useUserAuth';
import { filterNavItem } from 'utils/navigateUtils';

import s from './Navigation.module.scss';

interface IMainNav {
  transparent: boolean;
  dark: boolean;
  isSticky?: boolean;
  navItems: Array<INavItem>;
  onAction: (actionName: string, url?: string) => void;
}

const MainNav = ({ transparent, dark, isSticky, navItems, onAction }: IMainNav) => {
  const authDetails = useUserAuth();

  const getLink = (
    key: string,
    name: string,
    url: string,
    icon?: string,
    newTab?: boolean,
    menuItems?: IMenuItem[],
    otherUrls?: string[]
  ) => {
    return menuItems ? (
      <NavMenu
        key={key}
        name={name}
        url={url}
        icon={icon}
        newTab={newTab}
        transparent={transparent}
        dark={dark}
        otherUrls={otherUrls}
        isSticky={isSticky}
        menuItems={menuItems}
        onAction={onAction}
      />
    ) : (
      <NavLink
        key={key}
        name={name}
        url={url}
        icon={icon}
        newTab={newTab}
        transparent={transparent}
        dark={dark}
        otherUrls={otherUrls}
        isSticky={isSticky}
        onAction={onAction}
      />
    );
  };

  return (
    <div className={cn(s.Navigation__mainWrapper, { transparent, dark, isSticky })}>
      <nav
        className={cn(s.Navigation__content, {
          transparent,
          dark,
          isSticky
        })}
        data-testid="navigation_content"
      >
        {navItems
          .filter((item) => filterNavItem(item, authDetails))
          .map(({ name, url, icon, newTab, menuItems, otherUrls }, id) => {
            return getLink(`nav-${id}`, name, url, icon, newTab, menuItems, otherUrls);
          })}
      </nav>
    </div>
  );
};

export default MainNav;
